module.exports = {
    GetRequest: "GET"
};
